"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimPermissions = void 0;
var constants_1 = require("@hobt/constants");
exports.ClaimPermissions = {
    Claim: {
        AddAttachment: {
            modules: [constants_1.Module.Claim],
            roles: [
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.BusinessUser,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.MasterUser,
                constants_1.UserRole.ServiceProvider,
            ],
        },
        Create: {
            modules: [constants_1.Module.Claim],
            roles: [
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.ServiceProvider,
            ],
        },
        Read: {
            modules: [constants_1.Module.Claim],
            roles: [
                // i.e. get Adjudicators list, get Document ACL
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.BusinessUser,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.MasterUser,
                constants_1.UserRole.ReadOnly,
                constants_1.UserRole.ServiceProvider,
            ],
        },
        Submit: {
            modules: [constants_1.Module.Claim],
            roles: [
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.ServiceProvider,
            ],
        },
    },
    DraftClaim: {
        Delete: {
            modules: [constants_1.Module.Claim],
            roles: [
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.MasterUser,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.ServiceProvider,
            ],
        },
        Read: {
            modules: [constants_1.Module.Claim],
            roles: [
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.MasterUser,
                constants_1.UserRole.ReadOnly,
                constants_1.UserRole.ServiceProvider,
            ],
        },
        Update: {
            modules: [constants_1.Module.Claim],
            roles: [
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.ServiceProvider,
            ],
        },
    },
    FinalClaim: {
        Approve: {
            modules: [constants_1.Module.Claim],
            roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.MasterUser],
        },
        AutoAdjudicate: {
            modules: [constants_1.Module.Claim],
            roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.MasterUser],
        },
        Cancel: {
            modules: [constants_1.Module.Claim],
            roles: [
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.BusinessUser,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.MasterUser,
                constants_1.UserRole.ServiceProvider,
            ],
        },
        Decline: { modules: [constants_1.Module.Claim], roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.MasterUser] },
        Delete: { modules: [constants_1.Module.Claim], roles: [constants_1.UserRole.MasterUser] },
        PreviewCalculations: {
            modules: [constants_1.Module.Claim],
            roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
        },
        Read: {
            modules: [constants_1.Module.Claim],
            roles: [
                constants_1.UserRole.ApprovedLender,
                constants_1.UserRole.BusinessUser,
                constants_1.UserRole.Clerk,
                constants_1.UserRole.LenderAdministrator,
                constants_1.UserRole.MasterUser,
                constants_1.UserRole.ReadOnly,
                constants_1.UserRole.ServiceProvider,
            ],
        },
        ReadApprovals: {
            modules: [constants_1.Module.Claim],
            roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
        },
        ReadRemark: {
            modules: [constants_1.Module.Claim],
            roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
        },
        StatusOverride: { modules: [constants_1.Module.Claim], roles: [constants_1.UserRole.MasterUser] },
        Update: {
            modules: [constants_1.Module.Claim],
            roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
        },
        UpdateRemark: {
            modules: [constants_1.Module.Claim],
            roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
        },
    },
};
